import type { ReactNode } from 'react'
import { type Report, useSuspenseDecrypt } from '../hooks'
import { AttachmentList } from './AttachmentList'
import type { Attachment } from './FormItemsAnswers'

type MoreInformationContentProps = {
  report: Report
  attachments: Attachment[]
  onDownload: (attachment: Attachment) => Promise<boolean>
  renderText?: (text: string) => ReactNode
  renderRow?: (content: ReactNode) => ReactNode
}

export const MoreInformationContent = ({
  report,
  attachments,
  onDownload,
  renderText,
  renderRow,
}: MoreInformationContentProps) => {
  const { moreInfo } = useSuspenseDecrypt(report)

  if (!moreInfo && attachments.length === 0) {
    return null
  }

  const content = (
    <>
      {moreInfo && (renderText ? renderText(moreInfo) : moreInfo)}
      {attachments.length > 0 && (
        <div className='mt-1'>
          <AttachmentList attachments={attachments} config={{ onDownload }} />
        </div>
      )}
    </>
  )

  return renderRow ? renderRow(content) : content
}
